import { useState, useEffect } from 'react';
import { $getSelection, $isRangeSelection, $createParagraphNode } from 'lexical';
import { $createHeadingNode, $isHeadingNode, HeadingTagType } from '@lexical/rich-text';
import { $setBlocksType } from '@lexical/selection';
import { $isListNode, $isListItemNode } from '@lexical/list';
import { useRichTextEditor } from '../RichTextEditorProvider';
import { Select, MenuItem, FormControl } from '@mui/material';
import { editorHeadingStyles } from '../richTextEditorStyles';

export const HeadingSelector = () => {
  const { editor } = useRichTextEditor();
  const [blockType, setBlockType] = useState<string>('paragraph');

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }: any) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const anchorNode = selection.anchor.getNode();
          const element =
            anchorNode.getKey() === 'root' ? anchorNode : anchorNode.getTopLevelElementOrThrow();

          // Don't show heading type if we're in a list
          const isInList = $isListNode(element) || $isListItemNode(element);
          if (isInList) {
            setBlockType('paragraph');
            return;
          }

          if ($isHeadingNode(element)) {
            setBlockType(element.getTag());
          } else {
            setBlockType('paragraph');
          }
        }
      });
    });
  }, [editor]);

  const handleHeadingChange = (value: string) => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        if (value === 'paragraph') {
          $setBlocksType(selection, () => $createParagraphNode());
        } else {
          $setBlocksType(selection, () => $createHeadingNode(value as HeadingTagType));
        }
      }
    });
  };

  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <Select
        value={blockType}
        onChange={(e) => handleHeadingChange(e.target.value)}
        displayEmpty
        sx={{
          border: 'none',
          '& fieldset': {
            border: 'none',
          },
        }}
      >
        <MenuItem value="paragraph">Normal</MenuItem>
        <MenuItem value="h1" sx={editorHeadingStyles.h1}>
          Heading 1
        </MenuItem>
        <MenuItem value="h2" sx={editorHeadingStyles.h2}>
          Heading 2
        </MenuItem>
        <MenuItem value="h3" sx={editorHeadingStyles.h3}>
          Heading 3
        </MenuItem>
        <MenuItem value="h4" sx={editorHeadingStyles.h4}>
          Heading 4
        </MenuItem>
        <MenuItem value="h5" sx={editorHeadingStyles.h5}>
          Heading 5
        </MenuItem>
      </Select>
    </FormControl>
  );
};
